<script lang="ts" setup>
import { SwipeModal } from '@takuma-ru/vue-swipe-modal'
import { PropsType } from './CommunityBottomSheet'

const props = defineProps<PropsType>()
const emit = defineEmits(['update:modelValue'])

const updateModelValue = (value: boolean) => {
  emit('update:modelValue', value)
}
</script>

<template>
  <SwipeModal
    class="community-bottom-sheet"
    v-bind="props"
    :model-value="modelValue"
    @update:model-value="updateModelValue"
  >
    <div class="community-bottom-sheet-content">
      <div class="community-bottom-sheet-header">
        <slot name="header" />
      </div>
      <div class="community-bottom-sheet-body">
        <slot />
      </div>
      <div class="community-bottom-sheet-footer">
        <slot name="footer" />
      </div>
    </div>
  </SwipeModal>
</template>

<style scoped>
.community-bottom-sheet {
  background-color: var(--background) !important;
}
.community-bottom-sheet-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.community-bottom-sheet-header,
.community-bottom-sheet-footer {
  flex-shrink: 0;
}

.community-bottom-sheet-body {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
